import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { map, mapTo, scan, startWith, takeUntil } from 'rxjs/operators';
import { combineLatest, merge, Observable, Subject } from 'rxjs';
import { NbSidebarService, NbTabComponent } from '@nebular/theme';
import * as moment from 'moment';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import * as period from '../../../../data/period.json';
import { DateService } from '../service/date.service';
import { MedicineData } from '../../../../@core/interfaces/masters/medicine';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { PharmacyIndent, PharmacyIndentData } from '../../../../@core/interfaces/masters/pharmacyindent';
import { ToastrAppSrvcService } from '../../../../_services/toastr-app-srvc.service';
import { environment } from '../../../../../environments/environment';
import { PharmacyIndentDetails } from '../../../../@core/interfaces/masters/pharmacyindentdetails';
import { FileExportService } from '../../../../@core/backend/common/services/file-export.service';
import { Location } from '@angular/common';
import { access } from '../../../../data/access-constants';
import { LayoutService } from '../../../../@core/utils';




@Component({
  selector: 'ngx-ip-nurse-indent',
  templateUrl: './ip-nurse-indent.component.html',
  styleUrls: ['./ip-nurse-indent.component.scss']
})
export class IpNurseIndentComponent implements OnInit {
  @Input() isNurseIndentPageView : any
  @Input() isNurseIndentPageEdit: any;
  @Input() isNurseIndentPageCreate: any;
  @Input() isNurseIndentPagePrint: any;
  @Input() isNurseIndentPageDelete :any;
  @Input() isNurseIndentPageExport :any;
  jobCategory=localStorage.getItem('jobCategoryId');
  userFlag=localStorage.getItem("userFlag");
  indentStatusList = [
    { name: 'All', value: 'All', state: false },
    { name: 'Open', value: 'Open', state: true },
    { name: 'Partially Completed', value: 'Partially Completed', state: true },
    { name: 'Completed', value: 'Completed', state: false },
    { name: 'Closed', value: 'Closed', state: false }
  ];
  trackingIndentListDup:phNurseIndentMstDto[]=[];
  indentViewOptions = [
    { id: 'inlineRadio1', label: 'Show all Indent', value: 'Show all Indent' },
    { id: 'inlineRadio2', label: 'Show Each Indent wise', value: 'Show Each Indent wise' },
  ];
  selectedOption: string = this.indentViewOptions[0]?.value;
  showPagination: boolean = false;
  p:number=1;
  notesForm: FormGroup[] = [];
  indentStatusUpdateData: Array<any> = [];
  notesValue: string;
  indentStatusUpdatePopup: boolean = false;
  currentUpdateIndentMst:any;
  isUpdateError: boolean = false;
  isUpdateSuccess: boolean = false;
  constructor(private fb: FormBuilder,protected medicineSrvc: MedicineData,private router:Router,public location: Location,
    public dateService: DateService, private rolesData: RolesData,private pharmacyIndentService: PharmacyIndentData,private toaster: ToastrAppSrvcService,private filexport: FileExportService,
    private sidebarService: NbSidebarService,private layoutService: LayoutService) { 
    if(this.isInitializedByRouting()) {
      this.fetchPageAccess()
    }
    this.indentEditForm = this.fb.group({
      qty: this.fb.control(null),
      mid: this.fb.control(null),
      nurseId:this.fb.control(null),
      advicedBy:this.fb.control(null),
      usageInstruction:this.fb.control(null),
      indentDate:this.fb.control(null)
    });

    this.sentToPharmacyForm = this.fb.group({
      purpose: this.fb.control(null,[Validators.required]),
      priority: this.fb.control(null,[Validators.required]),
    })
  }
  protected readonly unsubscribe$ = new Subject<void>();
  private tenantId:string = localStorage.getItem("tenantId");
  private branchId:string = localStorage.getItem("branchId");
  private userId:number = parseInt(localStorage.getItem("userId"));

  private isInitializedByRouting(): boolean {
    return this.router.url === '/pages/nurse/patient-indent-monitoring';
  }

  get fval(): { [key: string]: AbstractControl } { return this.indentEditForm.controls; }
  get sval(): { [key: string]: AbstractControl } { return this.sentToPharmacyForm.controls; }
  get apiUrl(): string { return environment.apiUrl;}
  draftIndentList:phNurseIndentMstDto[]=[]
  trackingIndentList:phNurseIndentMstDto[]=[]
  pastIndentList:phNurseIndentMstDto[]=[]
  allIndentList:phNurseIndentMstDto[]=[]
  MedicineList:Array<any>=[]
  empList: any[]=[];
  doctorList:Array<{id:string,displayName:string,departmentName:string}>=[];
  purposeList:Array<any>=[]

  indentEditForm: FormGroup;
  sentToPharmacyForm:FormGroup
  currentIndentMst:phNurseIndentMstDto;

  regId:string;
  visitDoctorid: string;
  currentTab:string='Draft Indent'

  visitId:number;
  admissionId:number;
  mstIndex:number=null

  apiRestriction:boolean=true
  indentCreatePopUp:boolean=false
  medicinePopUp:boolean=false
  hideAddBtn:boolean=true
  allowClear:boolean = false
  sendtoPharmacyPopUp:boolean=false
  cancelFlag:boolean=false
  stpBtn:string='Send to Pharmacy'
  max:Date=moment().endOf('day').toDate();
  @ViewChild('matSelectInfiniteScroll', { static: true }) infiniteScrollSelect: MatSelect;
  @ViewChild('someRef') someRef;
  @ViewChild('matSelectInfiniteScrollPhy', { static: true }) PhyinfiniteScrollSelect: MatSelect;
  @ViewChild('someRefPhy') PhysomeRef;
  trackingListPageFlag:boolean=this.isInitializedByRouting()
  batchSize:number = 10;
  itemsCtrl: FormControl = new FormControl();
  searchCtrl:FormControl = new FormControl('');
  private incrementBatchOffset$: Subject<void> = new Subject<void>();
  private resetBatchOffset$: Subject<void> = new Subject<void>();
  private destroy$: Subject<void> = new Subject<void>();
  skip:number=0;
  take:number=  100
  periodList: string[] = (period as any).default;
  fromDate:Date | string= this.dateService.utcFromDate(new Date());
  toDate:Date | string = this.dateService.utcToDate(new Date());
  rangeDate: Date[];
  period:String ='Today'
  wardList:Array<any>=[]
  page:number=1

  //Phy
  batchSizePhy = 10;
  itemsCtrlPhy: FormControl = new FormControl();
  searchCtrlPhy = new FormControl('');
  private incrementBatchOffsetPhy$: Subject<void> = new Subject<void>();
  private resetBatchOffsetPhy$: Subject<void> = new Subject<void>();
  private destroyPhy$: Subject<void> = new Subject<void>();

  private filteredDataPhy$: Observable<any[]> = this.searchCtrlPhy.valueChanges.pipe(
    startWith(''),
    map(searchKeyword => {
      if (!searchKeyword) {
        return this.doctorList;
      }
      return this.doctorList.filter(item =>
          item.displayName.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        item.departmentName.toLowerCase().includes(searchKeyword.toLowerCase())

      );
    })
  );
  private minimumBatchOffsetPhy$: Observable<number> = combineLatest([
    this.filteredDataPhy$,
    this.searchCtrlPhy.valueChanges
  ]).pipe(
    map(([filteredData, searchValue]) => {
      if (!this.searchCtrlPhy.value) {
        const index = filteredData.findIndex(item => item.id === this.itemsCtrlPhy.value);
        return index + this.batchSizePhy;
      }
      return 0;
    }),
    startWith(0)
  );

  private batchOffsetPhy$ = combineLatest([
    merge(
      this.incrementBatchOffsetPhy$.pipe(mapTo(true)),
      this.resetBatchOffsetPhy$.pipe(mapTo(false))
    ),
    this.minimumBatchOffsetPhy$
  ]).pipe(
    scan((batchOffsetPhy, [doIncrement, minimumOffset]) => {
      if (doIncrement) {
        return Math.max(batchOffsetPhy + this.batchSizePhy, minimumOffset + this.batchSizePhy);
      } else {
        return Math.max(minimumOffset, this.batchSizePhy);
      }
    }, this.batchSizePhy)
  );

  filteredBatchedDataPhy$: Observable<any[]> = combineLatest([
    this.filteredDataPhy$,
    this.batchOffsetPhy$
  ]).pipe(
    map(([filteredData, batchOffsetPhy]) => filteredData.slice(0, batchOffsetPhy))
  );

  
  //Employee
  private filteredData$: Observable<any[]> = this.searchCtrl.valueChanges.pipe(
    startWith(''),
    map(searchKeyword => {
      if (!searchKeyword) {
        return this.empList;
      }
      return this.empList.filter(item =>
        item.firstName.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        item.lastName.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        item.empNumber.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        item?.jobCategory?.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
        item?.designation?.name.toLowerCase().includes(searchKeyword.toLowerCase()) 
        || item?.branchName?.name.toLowerCase().includes(searchKeyword.toLowerCase())
      );
    })
  );

  private minimumBatchOffset$: Observable<number> = combineLatest([
    this.filteredData$,
    this.searchCtrl.valueChanges
  ]).pipe(
    map(([filteredData, searchValue]) => {
      if (!this.searchCtrl.value) {
        const index = filteredData.findIndex(item => item.id === this.itemsCtrl.value);
        return index + this.batchSize;
      }
      return 0;
    }),
    startWith(0)
  );

  private batchOffset$ = combineLatest([
    merge(
      this.incrementBatchOffset$.pipe(mapTo(true)),
      this.resetBatchOffset$.pipe(mapTo(false))
    ),
    this.minimumBatchOffset$
  ]).pipe(
    scan((batchOffset, [doIncrement, minimumOffset]) => {
      if (doIncrement) {
        return Math.max(batchOffset + this.batchSize, minimumOffset + this.batchSize);
      } else {
        return Math.max(minimumOffset, this.batchSize);
      }
    }, this.batchSize)
  );

  filteredBatchedData$: Observable<any[]> = combineLatest([
    this.filteredData$,
    this.batchOffset$
  ]).pipe(
    map(([filteredData, batchOffset]) => filteredData.slice(0, batchOffset))
  );

 
  

  getNextBatch(): void { this.incrementBatchOffset$.next(); }
  getNextBatchPhy(): void { this.incrementBatchOffsetPhy$.next(); }


  ngOnInit(): void {
    if(this.trackingListPageFlag) {
      this.currentTab='Tracking Indent'
      this.onSearch()
      this.loadMedicine();
      this.getNurseIndentDDList()
      this.fetchTenantBasedPupose();
      this.loadWard();
        const tcontent = localStorage.getItem('Title');
    if (tcontent) {
      if(tcontent == 'Medi-Admin-phar'){
       
          this.indentStatusList = [
      { name: 'All', value: 'All', state: false },
      { name: 'Open', value: 'Open', state: false },
      { name: 'Partially Completed', value: 'Partially Completed', state: false },
      { name: 'Completed', value: 'Completed', state: true },
      { name: 'Closed', value: 'Closed', state: true }
    ];
        }
      localStorage.removeItem('Title');
    
    } 
  }
  }
  

  async fromDashboard(admissionId: any, visitId: any, regId: any,visitDoctorid:any) {
    this.admissionId = admissionId;
    this.visitId = visitId;
    this.regId = regId;
    this.visitDoctorid=visitDoctorid;
    if(this.apiRestriction){
      this.currentTab='Draft Indent'
      if(this.isFromCareEntry){
      this.fetchPageAccess()
      }
      this.loadMedicine();
      this.getNurseIndentDDList()
      this.getNurseIndentMstById(["New"]);
      this.fetchTenantBasedPupose();
      this.apiRestriction = false
    }
    this.currentIndentMst=null
  }

  loadMedicine(): void {
    this.medicineSrvc.list("medicine/" + this.tenantId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.MedicineList = data?.value;
      this.MedicineList.map(x => x.name = x?.name);
    }, (error) => {
    }, () => {

    });
  }
  searchModel = {
    wardId: '',
    bedNo: '',
    patientName: '',
    admId: '',
    indentId: '',
    selectedDoctorId: null,
    selectedNurseId: null
  };
  getNurseIndentDDList() :void { 
  this.pharmacyIndentService
  .list(`phIndentMst/${this.tenantId}/${this.branchId}/LoadNurseIndentDropdown`)
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe(
    (data: any) => {
      this.empList = data?.details?.nurseList ? data.details.nurseList : []
      this.doctorList = data?.details?.doctorList ? data.details.doctorList : []
      this.PhyinfiniteScrollSelect.openedChange.pipe(takeUntil(this.destroyPhy$)).subscribe(opened => {
        // after opening, reset the batch offset
        if (opened && this.doctorList.length > 0) {
          this.resetBatchOffsetPhy$.next();
          this.searchCtrlPhy.setValue("");
        }
      });

      this.infiniteScrollSelect.openedChange.pipe(takeUntil(this.destroy$)).subscribe(opened => {
        // after opening, reset the batch offset
        if (opened && this.empList.length > 0) {
          this.resetBatchOffset$.next();
          this.searchCtrl.setValue("");
        }
      });
    },
    (error) => {
      
     },
    () => {
    
    });
}

getNurseIndentMstById(statusList:string[]) :void { 
  const searchDto:any = {
    regId:this.regId,
    admId:this.admissionId,
    tenantId :this.tenantId,
    branchId :this.branchId,
    indentMstId :0,
    status:statusList,
  }
  this.pharmacyIndentService
  .create(`${this.apiUrl}/phIndentMst/${this.tenantId}/${this.branchId}/GetNurseIndentListByAdmId`,searchDto)
  .pipe(takeUntil(this.unsubscribe$))
  .subscribe(
    (data: any) => {
      if(this.currentTab === 'Draft Indent') {
        this.draftIndentList = data?.details?.phIndentMstList ? data.details.phIndentMstList : []
        this.draftIndentList.forEach(item=>{
          item.phIndentDate=''+this.getLocalDate(item.phIndentDate)
          item.updatedDate= item.updatedDate ? new Date(this.getLocalDate(item.updatedDate)) : null
          item.isExpand = true
          item.saveEnable = false
          item.isLocked = item?.isLocked
          item.lockStatusValue = item.lockStatusValue || 'Pending'
          item.medicines.forEach(med=>{
            med.createdDate= med.createdDate ? new Date(this.getLocalDate(med.createdDate)) : null
          })
        })   
      }
      else if(this.currentTab === 'Tracking Indent') {
        this.trackingIndentList = data?.details?.phIndentMstList ? data.details.phIndentMstList : []
        this.trackingIndentList.forEach(item=>{
          item.phIndentDate=''+this.getLocalDate(item.phIndentDate)
          item.updatedDate= item.updatedDate ? new Date(this.getLocalDate(item.updatedDate)) : null
          item.isExpand = true
          item.saveEnable = false
          item.isLocked = item?.isLocked
          item.lockStatusValue = item.lockStatusValue || 'Pending'
          item.medicines.forEach(med=>{
            med.createdDate= med.createdDate ? new Date(this.getLocalDate(med.createdDate)) : null
            med.newIndentStatus = "";
          })
        })
        if (this.trackingIndentList.length > 0) {
          this.notesForm = this.trackingIndentList.map(() =>
            this.fb.group({
              notes: ['', Validators.required],
            })
          );
        }         
      }
      else if(this.currentTab === 'Past Indent') {
        this.pastIndentList = data?.details?.phIndentMstList ? data.details.phIndentMstList : []
        this.pastIndentList.forEach(item=>{
          item.phIndentDate=''+this.getLocalDate(item.phIndentDate)
          item.updatedDate= item.updatedDate ? new Date(this.getLocalDate(item.updatedDate)) : null
          item.isExpand = true
          item.saveEnable = false
          item.isLocked = item?.isLocked
          item.lockStatusValue = item.lockStatusValue || 'Pending'
          item.medicines.forEach(med=>{
            med.createdDate= med.createdDate ? new Date(this.getLocalDate(med.createdDate)) : null
            med.phIndentCompletedDate= med.phIndentCompletedDate ? new Date(this.getLocalDate(med.phIndentCompletedDate)) : null
            
          })
        })   
      }
    
    },
    (error) => {
      
     },
    () => {
    
    });
}



onSearch():void {
  switch (this.period) {
    case 'Today':
      this.rangeDate = null;
      this.fromDate = this.dateService.utcFromDate(new Date());
      this.toDate = this.dateService.utcToDate(new Date());
      break;
    case 'Yesterday':
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const fromDate = new Date(yesterday);
      fromDate.setHours(0, 0, 0, 0); 
      const toDate = new Date(yesterday);
      toDate.setHours(23, 59, 59, 999);
      this.fromDate = fromDate;
      this.toDate = toDate;
      
      break;
    case 'This Week':
      const nowUTC = new Date(); // current time in UTC
      const istOffsetMs = 5.5 * 60 * 60 * 1000;
      const nowIST = new Date(nowUTC.getTime() + istOffsetMs);
      const dayIST = nowIST.getDay();

      const startOfWeekIST = new Date(nowIST);
      startOfWeekIST.setDate(nowIST.getDate() - dayIST);
      startOfWeekIST.setHours(0, 0, 0, 0);


      const endOfWeekIST = new Date(startOfWeekIST);
      endOfWeekIST.setDate(startOfWeekIST.getDate() + 6);
      endOfWeekIST.setHours(23, 59, 59, 999);

      const startOfWeekUTC = new Date(startOfWeekIST);
      const endOfWeekUTC = new Date(endOfWeekIST);
      this.fromDate = startOfWeekUTC
      this.toDate = endOfWeekUTC        
      break;
    case 'This Month':;
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const startOfMonthUTC = new Date(Date.UTC(year, month, 1, -5, -30, 0));
      const endOfMonthUTC = new Date(Date.UTC(year, month + 1, 0, 18, 29, 59));  
      this.fromDate = startOfMonthUTC
      this.toDate = endOfMonthUTC;      
      break;
    case 'This Year':
      const nowDate = new Date();
      const currentYear = nowDate.getFullYear();
      const startOfYear = new Date(currentYear, 0, 1, 0, 0, 0, 0);
      startOfYear.setDate(startOfYear.getDate() + 1); // Adds one day
      const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59, 999); //
      this.fromDate = startOfYear
      this.toDate = endOfYear;   
      
      break;
       case 'Between':
      if (this.rangeDate !== null && this.rangeDate !== undefined) {
        if (this.rangeDate[0] !== null && this.rangeDate[0] !== undefined && (this.rangeDate[1] == null || this.rangeDate[1] == undefined)) {
          this.fromDate = this.rangeDate[0];
          this.toDate =  this.dateService.utcToDate(new Date());
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] == null || this.rangeDate[0] == undefined)) {
          this.fromDate = null;
          this.toDate = this.rangeDate[1];
        }
        else if (this.rangeDate[1] !== null && this.rangeDate[1] !== undefined && (this.rangeDate[0] != null && this.rangeDate[0] != undefined)) {
          this.fromDate = this.rangeDate[0];
          this.toDate = this.rangeDate[1];
        }
      }
      break;
    default:
      this.rangeDate = null;
      this.fromDate = null;
      this.toDate = null;
      break;
  }
  this.allIndentList=[]
  this.trackingIndentList=[]
  this.getNurseIndentMstList()
}

searchDto:SearchDto  ={
  fromDate:null,
  toDate:null,
  skip:null,
  take:null,
  tenantId:this.tenantId,
  branchId:this.branchId,
  doctorId:null,
  nurseId:null,
}

  getNurseIndentMstList() :void { 
    const hasSearchParamsChanged = 
  this.fromDate !== this.searchDto.fromDate ||
  this.toDate !== this.searchDto.toDate ||
  this.skip !== this.searchDto.skip ||
  this.take !== this.searchDto.take ||
  this.searchModel.selectedDoctorId !== this.searchDto.doctorId ||
  this.searchModel.selectedNurseId !== this.searchDto.nurseId;
    // if(hasSearchParamsChanged){
        const searchDto:any ={
          fromDate: this.fromDate,
          toDate:this.toDate,
          skip:this.skip,
          take:this.take,
          tenantId:this.tenantId,
          branchId:this.branchId,
          doctorId:this.searchModel.selectedDoctorId,
          nurseId:this.searchModel.selectedNurseId,
        }
        this.searchDto =JSON.parse(JSON.stringify(searchDto)) 
        this.pharmacyIndentService
        .create(`${this.apiUrl}/phIndentMst/${this.tenantId}/${this.branchId}/GetNurseIndentList`,searchDto)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (data: any) => {
            
            this.trackingIndentList = data?.details?.phIndentMstList ? data.details.phIndentMstList : []
            this.trackingIndentList.forEach(item=>{
                item.phIndentDate=''+this.getLocalDate(item.phIndentDate)
                item.updatedDate= item.updatedDate ? new Date(this.getLocalDate(item.updatedDate)) : null
                item.admissionDate= item.admissionDate ? new Date(this.getLocalDate(item.admissionDate)) : null
                item.isExpand = true
                item.saveEnable = false
                item.isLocked = item?.isLocked
                item.lockStatusValue = item.lockStatusValue || 'Pending'
                item.medicines.forEach(med=>{
                  med.createdDate= med.createdDate ? new Date(this.getLocalDate(med.createdDate)) : null
                })
              if (item?.medicines?.length > 0) {
                item?.medicines?.forEach(el => {
                  el.newIndentStatus = "";
                });
            }
              }) 
              this.trackingIndentList.forEach(item => {
                this.allIndentList.push(item);
              });
            this.onKeyupSearch()
            this.trackingIndentListDup = this.trackingIndentList;
            if(this.trackingIndentList.length > 0){
              this.onstatusChange();
            }
           
          
          },
          (error) => {
            
           },
          () => {
          
          });
    // }
    // else{
    //   this.onKeyupSearch()
    //   this.trackingIndentListDup = this.trackingIndentList;
    //   if (this.trackingIndentList.length > 0) {
    //     this.onstatusChange();
    //   }
    // }
 
   
  }

  onKeyupSearch(): void {
    this.searchModel.admId = this.searchModel.admId.replace(/\D/g, '');
    this.searchModel.indentId = this.searchModel.indentId.replace(/\D/g, '');
    const model = this.searchModel;
      this.trackingIndentList = this.allIndentList.filter(item => {
      const matchesWard = !model.wardId || item.wardId === model.wardId;
      const matchesBed = !model.bedNo || item.bedNo?.toLowerCase().includes(model.bedNo.toLowerCase());
      const matchesPatient = !model.patientName || item.patientName?.toLowerCase().includes(model.patientName.toLowerCase());
      const matchesAdmId = !model.admId || item.admissionNo?.toString() === model.admId;
      const matchesIndentId = !model.indentId || item.phIndentNo?.toString() === model.indentId;  
      return (
        matchesWard &&
        matchesBed &&
        matchesPatient &&
        matchesAdmId &&
        matchesIndentId 
      );
    });
  }
  
  onReset(): void {
    this.searchModel = {
      wardId: '',
      bedNo: '',
      patientName: '',
      admId: '',
      indentId: '',
      selectedDoctorId: null,
      selectedNurseId: null
    };
    this.indentStatusList.forEach(item => {
      item.state = (item.name === 'Open' || item.name === 'Partially Completed');
    });
    this.indentStatusList[0].state==false;
    this.allIndentList=[]
    this.trackingIndentList=[]
    this.skip=0
    this.take=100
    this.page=1
    this.rangeDate=null
    this.period='Today'
    this.showPagination = false;
    this.selectedOption = this.indentViewOptions[0]?.value;
    this.p = 1;
    this.onSearch()
  }
  

  fetchTenantBasedPupose(){
    const masterTypes={
      masterTypes: ["INDENT_PURPOSE"]
    }
    this.rolesData.create(`${environment.apiUrl}/tenants/${this.tenantId}/masterreason/${this.branchId}/getMultipleTenantBasedMasters`, masterTypes).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.purposeList = data.details;
    })
  }

   

    createIndent():void {
      this.indentCreatePopUp=true;
      this.hideAddBtn=true
      this.medicinePopUp=true
      this.indentEditForm.reset();
      ['indentDate','nurseId','advicedBy','mid'].forEach(item=>{
       const formcontrol = this.fval[item] as FormControl
       formcontrol.clearValidators()
       formcontrol.updateValueAndValidity()
       formcontrol.setValidators([Validators.required])
       formcontrol.updateValueAndValidity()
     });
     (this.fval.qty as FormControl).clearValidators();
     (this.fval.qty as FormControl).setValidators([Validators.required, Validators.pattern('^[0-9]+$')]);
     (this.fval.qty as FormControl).updateValueAndValidity();
     this.PhyinfiniteScrollSelect.open(); 
     this.fval.indentDate.setValue(this.dateService.currentDate())
     this.fval.advicedBy.setValue(this.visitDoctorid)
     setTimeout(async () => {
      await this.sleep(1000);
       this.PhyinfiniteScrollSelect.close();
    });
     this.currentIndentMst=null
    }

    onAddMedicine(mstIndex:number):void {
      this.medicinePopUp = true;
      this.hideAddBtn= false;
      this.indentCreatePopUp=false
      this.mstIndex=mstIndex;
      this.currentIndentMst= this.currentTab == 'Draft Indent' ? this.draftIndentList[mstIndex] : this.trackingIndentList[mstIndex];
      this.indentEditForm.reset();
      ['indentDate','nurseId','advicedBy','mid','qty'].forEach(item=>{
        this.fval[item].clearValidators()
        this.fval[item].updateValueAndValidity()
       });
      if (this.currentTab == 'Draft Indent') {
        this.indentEditForm.controls['mid'].setValidators([Validators.required,
        this.alreadyExistsValidator(this.draftIndentList[mstIndex].medicines)
        ]);
      } else if (this.currentTab == 'Tracking Indent') {
        this.indentEditForm.controls['mid'].setValidators([Validators.required,
        this.alreadyExistsValidator(this.trackingIndentList[mstIndex].medicines)
        ]);
      }
        
      this.indentEditForm.controls['mid'].updateValueAndValidity();
       this.fval.qty.setValidators([Validators.required, Validators.pattern('^[0-9]+$')])
       this.fval.qty.updateValueAndValidity()
    }

    onTabChange(event:NbTabComponent) {
      this.currentTab=event.tabTitle
      if(event.tabTitle === 'Draft Indent') {
          this.getNurseIndentMstById(["New"])
      }
      else if(event.tabTitle === 'Tracking Indent'){
        this.getNurseIndentMstById(["Sent","Partially Delivered"])
      }
      else if(event.tabTitle === 'Past Indent'){
        this.getNurseIndentMstById(["Cancelled","Completed","Closed"])
      }
    }



    onSaveMedicine(event) {
        event.target.disable=true
        if(this.indentEditForm.valid) {
          let currentDetail:phNurseIndentDetDto = {
            phMedicineId:this.fval.mid.value,
            phIndentQty:this.fval.qty.value,
            phIndentReceivedQty: 0,
            phIndentBalanceQty: this.fval.qty.value,
            medicineUsageInstruction:this.fval.usageInstruction.value,
            createdDate:this.dateService.currentDate(),
            createdBy:this.userId,
            createdName:localStorage.getItem('userName'), 
            phIndentId:this.currentIndentMst.phIndentId,
            medicineName:this.MedicineList.find(item=>item.id === this.fval.mid.value).name,
            genericName:this.MedicineList.find(item=>item.id === this.fval.mid.value)?.genericName?.name ? 
            this.MedicineList.find(item=>item.id === this.fval.mid.value).genericName.name : '-',
            phIndentLineItemStatus: "Open"  
          }
          if (this.currentTab == 'Draft Indent') {
            if (this.draftIndentList[this.mstIndex].medicines.some(item => item.phIndentQty >= 1)) {
              this.draftIndentList[this.mstIndex].saveEnable = true
            }
            this.draftIndentList[this.mstIndex].medicines.push(currentDetail)
          } else if (this.currentTab == 'Tracking Indent') {
            if (this.trackingIndentList[this.mstIndex].medicines.some(item => Number(item.phIndentQty) >= 1)) {
              this.trackingIndentList[this.mstIndex].saveEnable = true
            }
            this.trackingIndentList[this.mstIndex].medicines.push(currentDetail);
          }
          
        }
        else {
          this.toaster.ForDanger("Please Fill required fields")
        }
        event.target.disable=false
        this.indentEditForm.reset()
    }


    addIndent(event,type:'Add' | 'Add New') {
      event.target.disable = true;
      this.indentEditForm.markAllAsTouched()
      if(this.indentEditForm.valid) {
        if(!!this.currentIndentMst) {
          const indentMst:PharmacyIndent = this.getIndentMatserValue({
            phIndentDate: this.fval.indentDate.value,
            phIndentNo:this.currentIndentMst?.phIndentNo,
            createdBy:this.currentIndentMst?.createdBy,
            createdDate:this.currentIndentMst?.createdDate,
            phEmployeeId:this.fval.nurseId.value || null,
            phBillId: this.currentIndentMst?.phBillId ? this.currentIndentMst.phBillId : "0",
            phIndentStatus:this.currentIndentMst?.phIndentStatus, 
            phIndentId: this.currentIndentMst?.phIndentId || 0, 
            phAdvicedById: this.fval.advicedBy.value,
            updatedDate:this.dateService.currentDate(),
            updatedBy:this.userId
          });
          if(!!this.currentIndentMst?.phIndentId) indentMst.id=''+this.currentIndentMst.phIndentId
          this.currentIndentMst.medicines.forEach(item=>{
            let detail = this.getIndentDetailValue({
              phMedicineId:item.phMedicineId,
              phIndentQty:item.phIndentQty,
              phIndentReceivedQty: item.phIndentReceivedQty,
              phIndentBalanceQty: item.phIndentBalanceQty,
              medicineUsageInstruction:item.medicineUsageInstruction,
              createdDate:item.createdDate,
              createdBy:item.createdBy,
              phIndentLineItemStatus: "Open"
              })
              if(item?.id) detail.id = item.id  
              if(!!this.currentIndentMst?.phIndentId) detail.phIndentId = this.currentIndentMst.phIndentId
              indentMst.phIndentDetDetDto.push(detail)
          })
          
          let currentDetail = this.getIndentDetailValue({
            phMedicineId:this.fval.mid.value,
            phIndentQty:this.fval.qty.value,
            phIndentReceivedQty: 0,
            phIndentBalanceQty: this.fval.qty.value,
            medicineUsageInstruction:this.fval.usageInstruction.value,
            createdDate:this.dateService.currentDate(),
            createdBy:this.userId,
            phIndentLineItemStatus: "Open"
            })
            currentDetail.phIndentId=this.currentIndentMst.phIndentId
            indentMst.phIndentDetDetDto.push(currentDetail)
            this.onUpdateIndent(event,indentMst,type)
        }
        else{
          const indentMst:PharmacyIndent = this.getIndentMatserValue({
            phIndentDate: this.fval.indentDate.value,
            phIndentNo:"",
            createdBy:this.userId,
            createdDate:this.dateService.currentDate(),
            phEmployeeId:this.fval.nurseId.value || null,
            phBillId: this.currentIndentMst?.phBillId ? this.currentIndentMst.phBillId : "0",
            phIndentStatus: "New", 
            phIndentId: this.currentIndentMst?.phIndentId|| 0, 
            phAdvicedById: this.fval.advicedBy.value,
           
          });
          indentMst.phIndentDetDetDto = [this.getIndentDetailValue({
            phMedicineId:this.fval.mid.value,
            phIndentQty:this.fval.qty.value,
            phIndentReceivedQty: 0,
            phIndentBalanceQty: this.fval.qty.value,
            medicineUsageInstruction:this.fval.usageInstruction.value,
            createdDate:this.dateService.currentDate(),
            createdBy:this.userId,
            phIndentLineItemStatus: "Open"
            })] 
          this.onSaveIndent(event,indentMst,type)
        }
      }
      else{
        this.toaster.ForDanger("Please fill required fields...")
        event.target.disable = false;
      } 
    }

    onDeleteMedicine(mstIndex,detIndex) {
       this.mstIndex=mstIndex
       if(this.currentTab === 'Draft Indent') {
        this.draftIndentList[mstIndex].medicines.splice(detIndex,1)
        if(this.draftIndentList[this.mstIndex].medicines.some(item=>item.phIndentQty > 1)){
          this.draftIndentList[this.mstIndex].saveEnable=true
        }
       }else if(this.currentTab === 'Tracking Indent') {
        this.trackingIndentList[mstIndex].medicines.splice(detIndex,1)
        if(this.trackingIndentList[this.mstIndex].medicines.some(item=>item.phIndentQty > 1)){
          this.trackingIndentList[this.mstIndex].saveEnable=true
        }
       }
    }

    onEditPurpose(mstIndex:number) {
      this.stpBtn='Update'
      this.sendtoPharmacyPopUp=true
      this.mstIndex=mstIndex
      this.sentToPharmacyForm.reset();
      this.sval.purpose.setValue(this.trackingIndentList[mstIndex].phPurpose)
      this.sval.priority.setValue(''+this.trackingIndentList[mstIndex].phIndentPriority)
    }

    onEditIndentDetail(mstIndex:number){
      this.indentCreatePopUp =true;
      this.medicinePopUp = false;
      this.hideAddBtn = false;
      this.indentEditForm.reset();
   
      ['indentDate','nurseId','advicedBy','mid','qty'].forEach(item=>{
        this.fval[item].clearValidators()
        this.fval[item].updateValueAndValidity()
       });
       ['indentDate','nurseId','advicedBy'].forEach(item=>{
        this.fval[item].setValidators([Validators.required])
        this.fval[item].updateValueAndValidity()
       })
       this.mstIndex=mstIndex
       if(this.currentTab === 'Draft Indent') {
        this.currentIndentMst=this.draftIndentList[mstIndex]
       }
       else if(this.currentTab ==='Tracking Indent') {
        this.currentIndentMst=this.trackingIndentList[mstIndex]
       }
    
       this.infiniteScrollSelect.open();
       this.PhyinfiniteScrollSelect.open(); 
      this.fval.nurseId.setValue(this.currentIndentMst.phEmployeeId)
      this.fval.advicedBy.setValue(this.currentIndentMst.phAdvicedById)
      this.fval.indentDate.setValue(this.dateService.dateUtctoLocal(this.currentIndentMst.phIndentDate,""))
      setTimeout(async () => {
        await this.sleep(1000);
        this.infiniteScrollSelect.close();
         this.PhyinfiniteScrollSelect.close();
      });
    }

    sleep(ms) {
      return new Promise(resolve=>setTimeout(resolve, ms));
    }

    updateIndent(event) {
      event.target.disable=true
      if(this.indentEditForm.valid){
        if(this.currentTab === 'Draft Indent') {
          this.currentIndentMst=this.draftIndentList[this.mstIndex]
         }
         else if(this.currentTab ==='Tracking Indent') {
          this.currentIndentMst=this.trackingIndentList[this.mstIndex]
         }
        this.currentIndentMst.phEmployeeId = this.fval.nurseId.value
        this.currentIndentMst.phIndentDate = this.fval.indentDate.value       
        this.currentIndentMst.nurseFirstName = this.empList.find(item=>item?.id ===this.fval.nurseId.value)?.firstName    
        this.currentIndentMst.phAdvicedByName = this.doctorList.find(item=>item.id === this.fval.advicedBy.value)?.displayName       
        this.currentIndentMst.phAdvicedById = this.fval.advicedBy.value
        this.currentIndentMst.phIndentDate = this.fval.indentDate.value       
       
        if(this.currentTab === 'Draft Indent') {
          this.draftIndentList[this.mstIndex].isExpand=true
          this.draftIndentList[this.mstIndex].saveEnable=true
         }
         else if(this.currentTab ==='Tracking Indent') {
          this.trackingIndentList[this.mstIndex].isExpand=true
          this.trackingIndentList[this.mstIndex].saveEnable=true
         }
        this.indentCreatePopUp =false
        this.medicinePopUp = false
      }
      else{
        event.target.disable=false
        this.toaster.ForDanger("Please Fill required fields")
      }
    }

    onSaveIndentChanges(mstIndex,event){
      event.target.disable=true
      this.mstIndex = mstIndex
      if(this.currentTab === 'Draft Indent') {
        this.currentIndentMst = this.draftIndentList[mstIndex]
      }
      else if(this.currentTab === 'Tracking Indent') {
        this.currentIndentMst = this.trackingIndentList[mstIndex]
      }
      try {
        if(this.trackingListPageFlag) {
          this.admissionId = this.trackingIndentList[mstIndex]?.admissionId
          this.regId = this.trackingIndentList[mstIndex]?.regId
          this.visitId = this.trackingIndentList[mstIndex]?.visitId
        }
        this.onUpdateIndent(event,this.updatedIndentMst,'Save Changes')
      }
      catch(ex) {
        event.target.disable=false
      }
          
    }

    get updatedIndentMst():PharmacyIndent{
      const indentMst:PharmacyIndent = this.getIndentMatserValue({
        phIndentDate:  this.currentIndentMst.phIndentDate,
        phIndentNo: this.currentIndentMst.phIndentNo,
        createdBy: this.currentIndentMst.createdBy,
        createdDate: this.currentIndentMst.createdDate,
        phEmployeeId: this.currentIndentMst.phEmployeeId,
        phBillId: this.currentIndentMst?.phBillId || "0",
        phIndentStatus: this.currentIndentMst.phIndentStatus, 
        phIndentId:  this.currentIndentMst.phIndentId, 
        phAdvicedById:this.currentIndentMst?.phAdvicedById || null,
        phPurpose:this.currentIndentMst?.phPurpose || null,
        phIndentPriority:+this.currentIndentMst?.phIndentPriority || null,
        updatedBy:+this.currentIndentMst?.updatedBy || null,
        updatedDate:this.currentIndentMst?.updatedDate || null
      });
      if(!!this.currentIndentMst?.phIndentId) indentMst.id=''+ this.currentIndentMst.phIndentId
      this.currentIndentMst.medicines.forEach(item=>{
        let detail = this.getIndentDetailValue({
          phMedicineId:item.phMedicineId,
          phIndentQty:item.phIndentQty,
          phIndentReceivedQty: item.phIndentReceivedQty,
          phIndentBalanceQty: (item.phIndentReceivedQty > 0 ? item.phIndentBalanceQty : item.phIndentQty),
          medicineUsageInstruction:item.medicineUsageInstruction,
          createdDate:item.createdDate,
          createdBy:item.createdBy,
          phIndentLineItemStatus:item.status || item?.phIndentLineItemStatus
          })
          if(item?.id) detail.id = item.id  
          if(!!this.currentIndentMst?.phIndentId) detail.phIndentId = this.currentIndentMst.phIndentId
          indentMst.phIndentDetDetDto.push(detail)

      })

      return indentMst
    }

    onQtyEntered(value:number,mstIndex,detIndex){
      if (value < 1) {
        if(this.currentTab === 'Draft Indent') {
          this.draftIndentList[mstIndex].saveEnable = false
        }
        else if(this.currentTab === 'Tracking Indent') {
          this.trackingIndentList[mstIndex].saveEnable = false
    
        }
      }
      else{
        if(this.currentTab === 'Draft Indent') {
          this.draftIndentList[mstIndex].saveEnable = true
          this.draftIndentList[mstIndex].medicines[detIndex].createdDate=this.dateService.currentDate()
          this.draftIndentList[mstIndex].medicines[detIndex].createdBy=this.userId
        }
        else if(this.currentTab === 'Tracking Indent') {
          if(this.trackingListPageFlag) {
            this.admissionId = this.trackingIndentList[mstIndex]?.admissionId
            this.regId = this.trackingIndentList[mstIndex].regId
            this.visitId = this.trackingIndentList[mstIndex].visitId
          }
          this.trackingIndentList[mstIndex].saveEnable = true
          this.trackingIndentList[mstIndex].medicines[detIndex].createdDate=this.dateService.currentDate()
          this.trackingIndentList[mstIndex].medicines[detIndex].createdBy=this.userId
        }
      }
      
    }


    onSaveIndent(event,indentMst:PharmacyIndent,savetype:string) {    
      this.pharmacyIndentService
      .create(`${this.apiUrl}/phIndentMst/${this.tenantId}/${this.branchId}`, indentMst)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (data: any) => {
          if(!!data?.details) {
            data.details.isExpand=true
            data.details.saveEnable=false
            data.details.phIndentDate = ''+this.getLocalDate(data.details.phIndentDate)
            data.details.updatedDate = data.details.updatedDate ? new Date(this.getLocalDate(data.details.updatedDate)) : null
            data.details.medicines.forEach(med=>{
              med.createdDate = med.createdDate ? new Date(this.getLocalDate(med.createdDate)) : null
            })
            this.draftIndentList.push(data.details)
            if(savetype === 'Add New') {
              this.currentIndentMst = data.details
              this.indentEditForm.controls['mid'].clearValidators();
              this.indentEditForm.controls['mid'].setValidators([Validators.required,
                this.alreadyExistsValidator(data.details.medicines)
              ]);  
              this.indentEditForm.controls['mid'].updateValueAndValidity();
            }
            else{
              this.currentIndentMst = null
            }
          } 
        },
        (error) => {
          this.toaster.ForDanger("Something went wrong...")
          event.target.disable = false;
         },
        () => {
            this.toaster.ForSuccess("Saved Successfully...")
            if(savetype === 'Add New') {
              this.hideAddBtn=false
              this.fval.mid.reset()
              this.fval.qty.reset()
              this.fval.usageInstruction.reset()
            } 
            else{
              this.indentCreatePopUp = false
              this.medicinePopUp = false
              this.hideAddBtn=true
            }
        });
    }

    onUpdateIndent(event,indentMst:PharmacyIndent,saveType:string) {
      if(this.currentIndentMst?.phIndentId){
        indentMst.updatedBy = this.userId
        indentMst.updatedDate = this.dateService.currentDate()
          this.pharmacyIndentService
          .update(`${this.apiUrl}/phIndentMst/${this.tenantId}/${this.branchId}/${this.currentIndentMst.phIndentId}`, indentMst)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (data: any) => {
        
              if(data?.details) {
                data.details.isExpand=true
                data.details.saveEnable=false
                data.details.phIndentDate = ''+this.getLocalDate(data.details.phIndentDate)
                data.details.updatedDate = data.details.updatedDate ? new Date(this.getLocalDate(data.details.updatedDate)) : null
                data.details.medicines.forEach(med=>{
                  med.createdDate = med.createdDate ? new Date(this.getLocalDate(med.createdDate)) : null
                })
                this.currentIndentMst = data.details
                if(this.currentTab ==='Draft Indent') {
                  if(saveType === 'Cancelled' || saveType ==='Sent'){
                    if(this.draftIndentList.some(item=>item.phIndentId === data?.details.phIndentId)) {
                      this.draftIndentList.splice(this.draftIndentList.findIndex(item=>item.phIndentId === data?.details.phIndentId),1)
                      saveType === 'Cancelled' ? this.pastIndentList.push(data.details) : this.trackingIndentList.push(data.details)
                    } 
                  }
                  else{
                    if(this.draftIndentList.some(item=>item.phIndentId === data?.details.phIndentId)) {
                      this.draftIndentList[this.draftIndentList.findIndex(item=>item.phIndentId === data?.details.phIndentId)] = data?.details
                    }
                    else{
                      this.draftIndentList.push(data.details)
                    }

                    if(saveType === 'Add New' && data?.details?.medicines) {
                      this.indentEditForm.controls['mid'].clearValidators();
                      this.indentEditForm.controls['mid'].setValidators([Validators.required,
                        this.alreadyExistsValidator(data.details.medicines)
                      ]);  
                      this.indentEditForm.controls['mid'].updateValueAndValidity();
                    } 
                  }
                }
                else if(this.currentTab ==='Tracking Indent') {
                  if(saveType === 'Cancelled'){
                    if(this.trackingIndentList.some(item=>item.phIndentId === data?.details.phIndentId)) {
                      this.trackingIndentList.splice(this.trackingIndentList.findIndex(item=>item.phIndentId === data?.details.phIndentId),1)
                      this.pastIndentList.push(data.details)
                    } 
                  }
                  else  if(this.trackingIndentList.some(item=>item.phIndentId === data?.details.phIndentId)){
                    if(this.trackingListPageFlag) {
                      const selectedItem = this.trackingIndentList.find(item => item.phIndentId === data?.details.phIndentId);
                      if (selectedItem) {
                        data.details.regId = selectedItem?.regId;
                        data.details.admissionId = selectedItem?.admissionId;
                        data.details.visitId = selectedItem?.visitId;
                        data.details.patientName = selectedItem?.patientName;
                        data.details.mobileNo = selectedItem?.mobileNo;
                        data.details.wardName = selectedItem?.wardName;
                        data.details.bedNo = selectedItem?.bedNo;
                        data.details.wardId = selectedItem?.wardId;
                        data.details.bedId = selectedItem?.bedId;
                        data.details.admissionNo = selectedItem?.admissionNo;
                        data.details.admissionDate = selectedItem?.admissionDate;
                      }
                     this.allIndentList[this.allIndentList.findIndex(item=>item.phIndentId === data?.details.phIndentId)] = data?.details
                    }
                    this.trackingIndentList[this.trackingIndentList.findIndex(item=>item.phIndentId === data?.details.phIndentId)] = data?.details
                    this.trackingIndentListDup = this.trackingIndentList;
                  
                  }
          
                }
                
              }
            },
            (error) => {
              this.toaster.ForDanger("Something went wrong")
              event.target.disable=false
            },
            () => {
              this.toaster.ForSuccess("Updated Successfully")
                event.target.disable=false
              if(saveType === 'Add New') {
                this.fval.mid.reset()
                this.fval.qty.reset()
                this.fval.usageInstruction.reset()
              }
              else if(saveType==='Cancelled'){
                  this.cancelFlag=false
              }
              else if(saveType==='Sent') {
                this.sendtoPharmacyPopUp = false
              }
              
            });
        }
        else{
          this.toaster.ForDanger("Something went wrong")
          event.target.disable=false
        }   
    }

    onSendToPharmacy(mstIndex:number) {
        this.sendtoPharmacyPopUp=true
        this.stpBtn='Send to Pharmacy'
        this.mstIndex=mstIndex
        this.currentIndentMst = this.draftIndentList[mstIndex]
        this.sentToPharmacyForm.reset()
        this.sval.priority.setValue(1)
    }

    onSaveToPharmacy(event):void {
        event.target.disable = true
        this.sentToPharmacyForm.markAllAsTouched()
       if(this.sentToPharmacyForm.valid) {
          if(this.currentTab ==='Draft Indent'){
            this.currentIndentMst.phIndentStatus = 'Sent'
            this.currentIndentMst.phPurpose =  this.sval.purpose.value
            this.currentIndentMst.phIndentPriority = +this.sval.priority.value
            this.onUpdateIndent(event,this.updatedIndentMst,'Sent')
          } 
          else if(this.currentTab ==='Tracking Indent') {
            this.trackingIndentList[this.mstIndex].phPurpose=this.sval.purpose.value
            this.trackingIndentList[this.mstIndex].phIndentPriority=+this.sval.priority.value
            this.trackingIndentList[this.mstIndex].isExpand=true
            this.trackingIndentList[this.mstIndex].saveEnable=true
            this.sendtoPharmacyPopUp = false
          }
        }
        else{
          event.target.disable = false
          this.toaster.ForDanger("Please Fill required fields")
        }
       

    } 
     
    onCancelIndent(mstIndex:number) {
        this.cancelFlag=true
        this.mstIndex=mstIndex
        if(this.currentTab === 'Draft Indent') {
          this.currentIndentMst = this.draftIndentList[mstIndex]
        }else if(this.currentTab === 'Tracking Indent') {
          this.currentIndentMst = this.trackingIndentList[mstIndex]
        }
    }

   
    
    confirmCancelIndent(event) {
      this.currentIndentMst.phIndentStatus = 'Cancelled'
      this.currentIndentMst.createdDate = this.dateService.currentDate()
      this.currentIndentMst.createdBy =this.userId
      if(this.trackingListPageFlag) {
        this.admissionId = this.currentIndentMst.admissionId
        this.regId = this.currentIndentMst.regId
        this.visitId = this.currentIndentMst.visitId
      }
      this.onUpdateIndent(event,this.updatedIndentMst,'Cancelled')
    }



  onUsageInstructionKeyup(): void {
    const value = this.fval.usageInstruction.value || '';
    const processed = value.split('\n')
                           .map(line => line.replace(/\s{2,}/g, ' '))
                           .join('\n');
    if (processed !== value) {
      this.fval.usageInstruction.setValue(processed, { emitEvent: false });
    }
  }

  

  alreadyExistsValidator(
    indentDetailList: phNurseIndentDetDto[]
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const exists = indentDetailList.some(item => 
        item?.phMedicineId === control.value
      );
  
      return exists ? { 'medicineExist': true } : null;
    };
  }

  getLocalDate(dateStr: string | Date | null): string | Date | null {
    if (!dateStr) return null;
    if (typeof dateStr === 'string' && !dateStr.endsWith('Z')) {
      dateStr += 'Z';
    }
    return dateStr;
  }

  getIndentMatserValue(value:phNurseIndentMstDto):PharmacyIndent {
    return {
      nphiesStatus:"Approved",
      phIndentDate:value.phIndentDate,
      phIndentNo:value?.phIndentNo ? 
      value.phIndentNo : "",
      phIndentFrom: "IP",
      regId: this.regId,
      admissionId: this.admissionId,
      customerId: 0,
      visitId: this.visitId,
      phIndentStatus:value?.phIndentStatus ? value.phIndentStatus : "",
      approvalDate: "",
      createdBy:''+ value?.createdBy,
      createdDate:value?.createdDate,
      updatedDate:value?.updatedDate || null,
      updatedBy:+value?.updatedBy || 0,
      phIndentDeliveryInstructions: "",
      phIndentNotes: "",
      phIndentCompletedDate: "",
      phIndentApproveStatus: "",
      phIndentApproveby: "",
      tenantId: this.tenantId,
      branchId: this.branchId,
      prescriptionIds: [],
      phdoctorid:value?.phAdvicedById,
      phBillId:value.phBillId,
      phHoldBillId:"0",
      archiveFlag: "N",
      archiveDoneby: null,
      archiveDonedatetime: null,
      phEmployeeId:value?.phEmployeeId || null,
      phIndentSubType:true,
      phPurpose:value?.phPurpose || null,
      phIndentPriority:+value?.phIndentPriority || null,
      phIndentDetDetDto: []
    }
  }

  getIndentDetailValue(value:phNurseIndentDetDto):PharmacyIndentDetails {
      return {
        medicineName:"",
        phIndentLineItemNo: 0,
        phMedicineId:value?.phMedicineId,
        phMedicineTakenInfo:null,
        phIndentQty:value?.phIndentQty,
        phIndentPriority: "",
        phIndentDeliveryInstruction: "",
        phIndentLineItemStatus: value?.phIndentLineItemStatus,
        tenantId: this.tenantId,
        branchId: this.branchId,
        phIndentApprovedQty: value?.phIndentApprovedQty || 0,
        phIndentReceivedQty: value?.phIndentReceivedQty || 0,
        phIndentBalanceQty: value?.phIndentBalanceQty || 0,
        medicineUsageInstruction:value?.medicineUsageInstruction,
        createdDate:value?.createdDate,
        createdBy:value?.createdBy,
      }
  }


  groupExpandDraft(i) {
    this.draftIndentList[i].isExpand = !this.draftIndentList[i].isExpand;
  }
  
  groupExpandTracking(i) {
    this.trackingIndentList[i].isExpand = !this.trackingIndentList[i].isExpand;
  }

  groupExpandPast(i) {
    this.pastIndentList[i].isExpand = !this.pastIndentList[i].isExpand;
  }

  expandAllDraft() {
    this.draftIndentList.map((ele) => ele.isExpand = true)
  }
  
  expandAllTracking() {
    this.trackingIndentList.map((ele) => ele.isExpand = true)
  }

  expandAllPast() {
    this.pastIndentList.map((ele) => ele.isExpand = true)
  }

  
  loadWard(): void {
      this.pharmacyIndentService.list("ward/" + this.tenantId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.wardList = data?.value ? data.value : [];
      }, (error) => {

      }, () => {
      });
    }

    allowOnlyNumbers(event: KeyboardEvent): void {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    }

    
  prevclicked():void
  {

    if(this.page>1)
    this.page= this.page - 1

  }
  nextclicked():void
  {
   if(this.page < (this.trackingIndentList.length/10))
   {
     this.page = this.page + 1
   }
   else{
    this.take+=100
    this.skip+=100
    this.getNurseIndentMstList()
  }
 }

 exportIndentList(type: string) {
  const currentDateTime = this.dateService.dateUtctoLocal(new Date(), 'DD-MM-YYYY h:mm:ss a');
  if(this.currentTab == 'Draft Indent' && !this.trackingListPageFlag){
    const indentHeader={
      value1: 'S No.',
      value2: 'Indent No.',
      value3: 'Indent Date / Time',
      value4: 'Status',
      value5: 'Doctor Name',
      value6: 'Nurse Name',
    }
    const ExportData:any[] =[];
    this.draftIndentList.forEach((indent, index) => {
      ExportData.push({
        value1:index + 1,
        value2:indent?.phIndentNo,
        value3:this.dateService.dateUtctoLocal(indent?.createdDate, 'DD-MM-YYYY hh:mm a') || '-',
        value4:indent?.phIndentStatus,
        value5:indent?.phAdvicedByName,
        value6:indent?.nurseFirstName
      });
      if (indent.medicines?.length>0) {
        ExportData.push({
          value1: '',
          value2: 'Medicine Name',
          value3: 'Generic Name',
          value4: 'Requested',
          value5: 'Sold',
          value6: 'Balance',
          value7: 'Notes',
          value8: 'Last Modified',
        });
        indent.medicines.forEach(med => {
          ExportData.push({
            value1: '',
            value2: med.medicineName || '-',
            value3: med.genericName || '-',
            value4: `${med.phIndentQty || 0}`,
            value5: `${med.phIndentReceivedQty || 0}`,
            value6: `${med.phIndentBalanceQty || 0}`,
            value7: med.medicineUsageInstruction|| '-',
            value8: `${med.createdName || '-'}\n${this.dateService.dateUtctoLocal(med.createdDate, 'DD-MM-YYYY hh:mm a') || '-'}`,
          });
        });
  
        ExportData.push({ value1: '' });
      }

      
    })
  
    const data = [
      {
        value1: '',
      },
      {
        value1: '',
      },
      indentHeader,
      ...ExportData
    ];
  
    this.filexport.newExcelExport(type, data, indentHeader, 'Draft Indent Report');
    
  }
  else if(this.currentTab == 'Tracking Indent' && !this.trackingListPageFlag){
    const indentHeader={
      value1: 'S No.',
      value2: 'Indent No.',
      value3: 'Indent Date / Time',
      value4: 'Doctor Name',
      value5: 'Nurse Name',
      value6: 'Priority / Purpose',
    }
    const ExportData:any[] =[];
    this.trackingIndentList.forEach((indent, index) => {
      ExportData.push({
        value1:index + 1,
        value2:indent?.phIndentNo,
        value3:this.dateService.dateUtctoLocal(indent?.phIndentDate, 'DD-MM-YYYY hh:mm a') || '-',
        value4:indent?.phAdvicedByName,
        value5:indent?.nurseFirstName,
        value6:indent?.phPurposeName,
      });
      if (indent.medicines?.length>0) {
        ExportData.push({
          value1: '',
          value2: 'Bill No',
          value3: 'Bill Date',
          value4: 'Medicine Name',
          value5: 'Generic Name',
          value6: 'Requested',
          value7: 'Sold',
          value8: 'Balance',
          value9: 'Status',
          value10: 'Notes',
          value11: 'Last Modified',
        });
        indent.medicines.forEach(med => {
          ExportData.push({
            value1: '',
            value2: med.billNo || '-',
            value3: med.lastSaleDate ? this.dateService.dateUtctoLocal(med.lastSaleDate, 'DD-MM-YYYY hh:mm a') : '-',
            value4: med.medicineName || '-',
            value5: med.genericName || '-',
            value6: `${med.phIndentQty || 0}`,
            value7: med.phIndentReceivedQty || 0,
            value8: med.phIndentBalanceQty || 0,
            value9: med.status || '-',
            value10: med.medicineUsageInstruction|| '-',
            value11: `${med.createdName || '-'}\n${this.dateService.dateUtctoLocal(med.createdDate, 'DD-MM-YYYY hh:mm a') || '-'}`,
          });
        });
  
        ExportData.push({ value1: '' });
      }

      
    })
  
    const data = [
      {
        value1: '',
      },
      {
        value1: '',
      },
      indentHeader,
      ...ExportData
    ];
  
    this.filexport.newExcelExport(type, data, indentHeader, 'Tracking Indent Report');
    
  }
  else if(this.currentTab == 'Past Indent' && !this.trackingListPageFlag){
    const indentHeader={
      value1: 'S No.',
      value2: 'Indent No.',
      value3: 'Indent Date / Time',
      value4: 'Status',
      value5: 'Received Date / Time ',
      value6: 'Priority/Purpose',
      value7: 'Doctor Name',
      value8: 'Nurse Name'
    }
    const ExportData:any[] =[];
    this.pastIndentList.forEach((indent, index) => {
      ExportData.push({
        value1:index + 1,
        value2:indent?.phIndentNo,
        value3:this.dateService.dateUtctoLocal(indent?.phIndentDate, 'DD-MM-YYYY hh:mm a') || '-',
        value4:indent?.phIndentStatus,
        value5: indent?.phIndentCompletedDate ? this.dateService.dateUtctoLocal(indent?.phIndentCompletedDate, 'DD-MM-YYYY hh:mm a') : '-',
        value6:indent?.phPurposeName,
        value7:`${indent?.phAdvicedByName}`,
        value8:`${indent?.nurseFirstName}`
      });
      if (indent.medicines?.length>0) {
        ExportData.push({
          value1: '',
          value2: 'Bill No',
          value3: 'Bill Date',
          value4: 'Medicine Name',
          value5: 'Generic Name',
          value6: 'Requested Qty',
          value7: 'Sold Qty',
          value8: 'Balance Qty',
          value9: 'Status',
          value10: 'Notes',
          value11: 'Last Modified',
        });
        indent.medicines.forEach(med => {
          ExportData.push({
            value1: '',
            value2: med.billNo || '-',
            value3: med.lastSaleDate ? this.dateService.dateUtctoLocal(med.lastSaleDate, 'DD-MM-YYYY hh:mm a') : '-',
            value4: med.medicineName || '-',
            value5: med.genericName || '-',
            value6: `${med.phIndentQty || 0}`,
            value7: med.phIndentReceivedQty || 0,
            value8: med.phIndentBalanceQty || 0,
            value9: med.status || '-',
            value10: med.medicineUsageInstruction|| '-',
            value11: `${med.createdName || '-'}\n${this.dateService.dateUtctoLocal(med.createdDate, 'DD-MM-YYYY hh:mm a') || '-'}`,
          });
        });
  
        ExportData.push({ value1: '' });
      }

      
    })
  
    const data = [
      {
        value1: '',
      },
      {
        value1: '',
      },
      indentHeader,
      ...ExportData
    ];
  
    this.filexport.newExcelExport(type, data, indentHeader, 'Past Indent Report');
    
  }
  else {

  const indentHeader = {
    value1: 'S No.',
    value2: 'Patient Name',
    value3: 'Mobile',
    value4: 'Admission # / Date',
    value5: 'Indent # / Date',
    value6: 'Ward / Bed',
    value7: 'Doctor',
    value8: 'Nurse',
    value9: 'Purpose / Priority',
    // value10: 'Updated By',
    // value11: 'Updated On',
    // value12: 'Duration',
  };

  const ExportData: any[] = [];

  this.trackingIndentList.forEach((indent, index) => {
    ExportData.push({
      value1: index + 1,
      value2: indent.patientName || '-',
      value3: indent.mobileNo || '-',
      value4: `${indent.admissionNo || '-'}\n${this.dateService.dateUtctoLocal(indent.admissionDate, 'DD-MM-YYYY hh:mm a') || '-'}`,
      value5: `${indent.phIndentNo || '-'}\n${this.dateService.dateUtctoLocal(indent.phIndentDate, 'DD-MM-YYYY hh:mm a') || '-'}`,
      value6: `${indent.wardName || '-'} / ${indent.bedNo || '-'}`,
      value7: indent.phAdvicedByName || '-',
      value8: indent.nurseFirstName || '-',
      value9: indent.phPurposeName || '-',
      // value10: indent.updatedByName || '-',
      // value11: indent.updatedDate ? this.dateService.dateUtctoLocal(indent.updatedDate, 'DD-MM-YYYY hh:mm a') : '-',
      // value12: indent.duration || '-',
    });

  
    if (indent.medicines?.length) {
      ExportData.push({
        value1: '',
        value2: 'Bill No',
        value3: 'Bill Date',
        value4: 'Medicine Name',
        value5: 'Generic Name',
        value6: 'Requested Qty',
        value7: 'Sold Qty',
        value8: 'Balance Qty',
        value9: 'Status',
        value10: 'Notes',
        value11: 'Last Modified',
        // value12: 'Updated Date',
      });

      indent.medicines.forEach(med => {
        ExportData.push({
          value1: '',
          value2: med.billNo || '-',
          value3: med.lastSaleDate ? this.dateService.dateUtctoLocal(med.lastSaleDate, 'DD-MM-YYYY hh:mm a') : '-',
          value4: med.medicineName || '-',
          value5: med.genericName || '-',
          value6: med.phIndentQty || 0,
          value7: med.phIndentReceivedQty || 0,
          value8: med.phIndentBalanceQty || 0,
          value9: med.status || '-',
          value10: med.medicineUsageInstruction || '-',
          value11: `${med.createdName || '-'}\n${this.dateService.dateUtctoLocal(med.createdDate, 'DD-MM-YYYY hh:mm a') || '-'}`,
        });
      });

      ExportData.push({ value1: '' }); 
    }
  });

  const filterRow = {
    value1: `Period: ${this.period || '-'}, From: ${new Date(this.fromDate).toLocaleDateString()}, To: ${new Date(this.toDate).toLocaleDateString()}`
  };

  const data = [
    filterRow,
    {
      value1: '',
    },
    indentHeader,
    ...ExportData
  ];

  this.filexport.newExcelExport(type, data, indentHeader, 'Nurse Indent Report');
}
}

pageTaskIds:Array<any>=[]
userAccessData:Array<any>=[]
isPrint:boolean=false
isExport:boolean=false
isEdit:boolean=false
isCreate:boolean=false
@Input() isFromCareEntry:boolean=false

fetchPageAccess() {
  this.pageTaskIds = [];
  if(this.trackingListPageFlag){
  this.pageTaskIds.push(access.task.PATIENTINDENTMONITORING);
  }
  else{
    this.pageTaskIds.push(access.task.PATIENTCAREENTRY);
  }
  let matrixSearchData:any = {
    taskId: this.pageTaskIds,
    UserId: localStorage.getItem("userType")
  }
  this.pharmacyIndentService.create(`${environment.apiUrl}/userrole/${this.tenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.userAccessData = data;
  }, (error) => {
  }, () => {

    if(this.trackingListPageFlag) {
      this.isCreate = true
      let isEdit = this.userAccessData.filter(element => access.task.PATIENTINDENTMONITORING == element.taskID && element.actionID == access.action.EDIT && element.permission == "true" )
      if(isEdit.length > 0) {this.isEdit = true}
      let isPrint = this.userAccessData.filter(element => access.task.PATIENTINDENTMONITORING == element.taskID && element.actionID == access.action.PRINT && element.permission == "true" )
      if(isPrint.length > 0) {this.isPrint = true}
      let isExport = this.userAccessData.filter(element => access.task.PATIENTINDENTMONITORING == element.taskID && element.actionID == access.action.EXPORT && element.permission == "true" )
      if(isExport.length > 0) {this.isExport = true}
    }
    else if(this.isFromCareEntry){
      let isCreate = this.userAccessData.filter(element => access.task.PATIENTCAREENTRY == element.taskID && element.actionID == access.action.CREATE && element.permission == "true" )
      if(isCreate.length > 0) {this.isCreate = true}
      let isEdit = this.userAccessData.filter(element => access.task.PATIENTCAREENTRY == element.taskID && element.actionID == access.action.EDIT && element.permission == "true" )
      if(isEdit.length > 0) {this.isEdit = true}
      let isPrint = this.userAccessData.filter(element => access.task.PATIENTCAREENTRY == element.taskID && element.actionID == access.action.PRINT && element.permission == "true" )
      if(isPrint.length > 0) {this.isPrint = true}
      let isExport = this.userAccessData.filter(element => access.task.PATIENTCAREENTRY == element.taskID && element.actionID == access.action.EXPORT && element.permission == "true" )
      if(isExport.length > 0) {this.isExport = true}
    }
  });
}  

  trackByMedDrop(index: number, item: any): number {
    return index;
  }

  resetIndentField():void {
      this.indentEditForm.reset()
  }

  onPOALLstatusChange() {
    if (this.indentStatusList[0]?.state == true) {
      this.indentStatusList.forEach(item => {
        if (item.name !== 'All') {
          item.state = true;
        }
      });
      this.onstatusChange();
    }
    else if (this.indentStatusList[0]?.state == false) {
      this.onstatusChange();
    }
  }

  onstatusChange() {
    this.page = 1;
    this.trackingIndentList = [];
    if (this.trackingIndentListDup.length > 0) {
      var poDet = JSON.parse(JSON.stringify(this.trackingIndentListDup));
      const selected = this.indentStatusList.filter(x => x.state === true && x.name !== 'All');

      // If nothing except All is selected → return full list
      if (selected.length === 0) {
        this.trackingIndentList = poDet;
        return;
      }
      poDet.forEach(item => {
        const vals = item?.medicines;
        if (vals.length > 0) {
          const sd = this.indentStatusList
            .filter(x => x.state === true && x.name !== 'All')
            .reduce((acc, x) => acc.concat(vals.filter(y => y.status  !== null && y.status .toLocaleLowerCase() === x.value.toLocaleLowerCase())), []);
          item.medicines = sd;
        }
      });
      this.trackingIndentList = poDet.filter(item => item.medicines.length > 0);

      this.notesForm = this.trackingIndentList.map(() =>
        this.fb.group({
          notes: ['', Validators.required],
        })
      );

      if (this.selectedOption == "Show Each Indent wise") {
        this.showPagination = true;
        this.p = 1;
      }
      else if (this.selectedOption == "Show all Indent") {
        this.showPagination = false;
        this.p = 1;
        this.page = 1;
      }
    }
  }

  onIndentViewChange(type) {
    this.notesForm.forEach(form => {
      const control = form.get('notes');
      if (control) {
        control.patchValue('');
         control.markAsUntouched();
      }
    });
    if (this.trackingIndentList.length > 0) {
      if (type == "Show Each Indent wise") {
        this.showPagination = true;
        // this.itemsPerPage = 1;
        this.p = 1;
        this.trackingIndentList[0].isExpand = true;
      }
      else if (type == "Show all Indent") {
        this.showPagination = false;
        // this.itemsPerPage = 10;
        this.p = 1;
        this.page=1;
      }
    }
  }

  indentWiseprevclicked() {
    if (this.p > 1)
      this.p = this.p - 1
    this.notesForm.forEach(form => {
      const control = form.get('notes');
      if (control) {
        control.patchValue('');
        control.markAsUntouched();
      }
    });
  }

  indentWisenextclicked() {
    if (this.p < (this.trackingIndentList.length)) {
      this.p = this.p + 1
      this.notesForm.forEach(form => {
        const control = form.get('notes');
        if (control) {
          control.patchValue('');
          control.markAsUntouched();
        }
      });
    }
  }

  checkAllIndentStatusClosed(val) {
    var FinalArr = val.filter(el => el.status == 'Close' || el.status == 'Completed');
    if (FinalArr.length == val.length) {
      return false;
    }
    else {
      return true;
    }
  }

  getFormControl(index: number, controlName: string) {
    const formGroup = this.notesForm[index];
    return formGroup ? formGroup.get(controlName) : null;
  }

  checkRemainChar(notesIndex) {
    const form = this.notesForm[notesIndex];

    var enterVal = this.getFormControl(notesIndex, 'notes').value;

    if (enterVal !== null && enterVal !== "") {
      return 200 - enterVal.length;
    }
  }

  checkPOStatusChangeSelected(val, index) {
    const notesControl = this.getFormControl(index, 'notes');

    const isNotesInvalid = notesControl && notesControl.valid;


    const filterArr = val.filter(el => el.newIndentStatus === 'Close' && el.status !== 'Close');
    const isCloseStatus = filterArr.length > 0;
    if (isNotesInvalid && isCloseStatus) {
      return false;
    } else if (!isNotesInvalid || !isCloseStatus) {
      return true;
    }

  }

  poStatusDropdownChange(id, event) {
    if (event.length > 0) {
      if (event[0]?.value == "Close") {
        this.trackingIndentList.forEach(item => {
          item.medicines.forEach(detail => {
            if (detail.id === id) {
              detail.newIndentStatus = "Close";
            }
          });
        });
      }
    }
    else {
      this.trackingIndentList.forEach(item => {
        item.medicines.forEach(detail => {
          if (detail.id === id) {
            detail.newIndentStatus = "";
          }
        });
      });
    }
  }

  indentStatusDropdownChange(id, event, mstIndex) {
    if (event.length > 0) {
      if (event[0]?.value == "Close") {
        this.trackingIndentList.forEach(item => {
          item.medicines.forEach(detail => {
            if (detail.id === id) {
              detail.newIndentStatus = "Close";
            }
          });
        });
      }
    }
    else {
      this.trackingIndentList.forEach(item => {
        item.medicines.forEach(detail => {
          if (detail.id === id) {
            detail.newIndentStatus = "";
          }
        });
      });
    }
    const hasClose = this.trackingIndentList[mstIndex]?.medicines?.some(
      detail => detail.newIndentStatus === "Close"
    );

    this.trackingIndentList[mstIndex].showUpdateBtn = hasClose;
  }

  poStatusListLoad(type) {
    if (type == "Open" || type == "Partially Completed") {
      return [
        { name: 'Close' }
      ]
    }
    else {
      return [];
    }
  }

  statusUpdate(value, notesIndex) {
    const form = this.notesForm[notesIndex];
    this.currentUpdateIndentMst=  this.trackingIndentList[notesIndex];

    this.notesValue = this.getFormControl(notesIndex, 'notes').value;

    this.indentStatusUpdateData = value
      .filter(el => el.newIndentStatus === 'Close' && el.status !== 'Close')
      .map(item => item.id);
    if (this.indentStatusUpdateData.length > 0) {
      this.indentStatusUpdatePopup = true;
    }
    else {
      this.indentStatusUpdatePopup = false;
      this.indentStatusUpdateData = [];
    }
  }

  update() {
    if (this.indentStatusUpdateData.length > 0 && this.notesValue !== "" && this.notesValue !== null) {
      const statusListFormatted = this.indentStatusUpdateData.map(id => ({
        id: id,
        phIndentLineItemStatus: 'Closed'
      }));
      let searchData: any = {
        updatedBy: this.userId,
        phIndentDetStatusList: statusListFormatted,
        phIndentNotes: this.notesValue,
      }
      this.pharmacyIndentService.updateStatus(`phIndentMst/${this.tenantId}/${this.branchId}/status/${this.currentUpdateIndentMst?.phIndentId}`, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      }, (error) => {
        this.indentStatusUpdateData = [];
        this.isUpdateError = true;
        setTimeout(() => {
          this.isUpdateError = false;
          this.indentStatusUpdatePopup = false;
        }, 2000);
      }, () => {
        if (this.trackingListPageFlag) {
          this.onSearch();
        } else {
          this.refresh();
        }
        this.indentStatusUpdatePopup = false;
        this.isUpdateSuccess = true;
        setTimeout(() => {
          this.isUpdateSuccess = false;
        }, 2000);
        this.indentStatusUpdateData = [];
      }
      );
    }
  }

  goToSales(x) {
    var link = "/pages/pharmacy/sales?id" + x.phIndentId + "?" + x.phIndentFrom;
    this.router.navigate([`${link.split('?')[0]}`], { queryParams: { id: x.phIndentId, indentFrom: x.phIndentFrom } });
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  getStyleForStatus(poItemStatus: string | undefined): any {
    var background, border, fontSize = '14px', color = 'White';

    if (poItemStatus != null) {
      if (poItemStatus.toLocaleLowerCase() === this.indentStatusList[1]?.value?.toLocaleLowerCase()) {
        background = '#8338EC';
        border = `1px solid ${background}`;
      } else if ((poItemStatus.toLocaleLowerCase() === this.indentStatusList[2]?.value?.toLocaleLowerCase()) || poItemStatus == 'Partial') {
        background = '#FFD814';
        border = `1px solid ${background}`;
        color = 'Black';
      } else if (poItemStatus.toLocaleLowerCase() === this.indentStatusList[3]?.value?.toLocaleLowerCase()) {
        background = '#0E7A39';
        border = `1px solid ${background}`;
      }
      else if (poItemStatus.toLocaleLowerCase() === this.indentStatusList[4]?.value?.toLocaleLowerCase()) {
        background = '#8C6129';
        border = `1px solid ${background}`;
      }
      else {
        // Default values or fallback if poItemStatus doesn't match any of the conditions
        background = 'defaultBackground';
        border = `1px solid ${background}`;
      }

      return { 'background-color': background, 'border': border, 'color': color, 'font-size': fontSize };
    } else {
      background = '#fff';
      border = `1px solid ${background}`;
      return { 'background-color': background, 'border': border, 'color': 'Black', 'font-size': fontSize };
    }

  }

  refresh(){
    this.getNurseIndentMstById(["Sent","Partially Delivered"]);
  }

  onEditIndentCloseStatus(medicine: any) {
    medicine.showCloseOption = !medicine.showCloseOption;
  }

  hideCloseOption(medicine: any,indent) {
    medicine.showCloseOption = false;
    medicine.newIndentStatus = "";
    indent.showUpdateBtn = false;
  }
}


export interface phNurseIndentMstDto {
  phIndentId?: number;
  phIndentNo: string;
  phEmployeeId: string;
  nurseFirstName?: string;
  nurseLastName?: string;
  createdDate: Date;
  phIndentDate: string;
  createdBy: number;
  updatedBy?: number;
  updatedDate?:Date;
  updatedName?:string;
  phBillId: string;
  phIndentStatus:string,
  isExpand?:boolean,
  saveEnable?:boolean,
  phAdvicedById?:string,
  phAdvicedByName?:string,
  phPurpose?:number,
  phPurposeName?:string,
  phIndentPriority?:number,
  phHoldBillId?:number,
  wardId?:any,
  bedId?:any,
  mobileNo?:string,
  wardName?:string,
  admissionDate?:Date,
  bedNo?:string,
  patientName?:string
  admissionNo?:any
  admissionId?:number
  regId?:string
  visitId?:number
  medicines?:phNurseIndentDetDto[],
  updatedByName?:string,
  duration?:string,
  phIndentCompletedDate?:Date,
  isLocked?: any;
  lockStatusValue?: string;
  showUpdateBtn?: boolean;

}

export interface phNurseIndentDetDto {
  id?: number;

  phIndentId?:number ;
  medicineName?: string;
  phIndentQty: number;
  medicineUsageInstruction: string;
  phMedicineId: string;
  phIndentBalanceQty?:number,
  phIndentReceivedQty?:number,
  createdDate:Date;
  createdBy:number;
  genericName?:string
  createdName?:string
  phIndentCompletedDate?:Date,
  billNo?:string,
  lastSaleDate?:Date,
  status?:string,
  phIndentLineItemStatus?:string;
  newIndentStatus?:string;
  phIndentApprovedQty?:number;
}

export interface SearchDto {
  fromDate: Date | null;
  toDate: Date | null;
  skip: number | null;
  take: number | null;
  tenantId: string;
  branchId: string;
  doctorId: number | null;
  nurseId: number | null;
}